﻿const data = [
	{ date: "20201204", high: "9.00", low: "7.27" },
	{ date: "20201207", high: "10.95", low: "8.70" },
	{ date: "20201208", high: "9.51", low: "9.05" },
	{ date: "20201209", high: "9.20", low: "8.50" },
	{ date: "20201210", high: "8.39", low: "7.78" },
	{ date: "20201211", high: "8.29", low: "7.97" },
	{ date: "20201214", high: "8.50", low: "8.20" },
	{ date: "20201215", high: "8.35", low: "8.19" },
	{ date: "20201216", high: "8.40", low: "8.14" },
	{ date: "20201217", high: "8.27", low: "8.15" },
	{ date: "20201218", high: "8.26", low: "8.14" },
	{ date: "20201221", high: "8.27", low: "8.07" },
	{ date: "20201222", high: "8.21", low: "8.12" },
	{ date: "20201223", high: "8.25", low: "8.11" },
	{ date: "20201224", high: "8.27", low: "8.21" },
	{ date: "20201229", high: "8.27", low: "8.16" },
	{ date: "20201230", high: "8.25", low: "8.18" },
	{ date: "20201231", high: "8.25", low: "8.17" },
	{ date: "20210104", high: "8.70", low: "8.27" },
	{ date: "20210105", high: "8.89", low: "8.65" },
	{ date: "20210106", high: "8.90", low: "8.56" },
	{ date: "20210107", high: "8.89", low: "8.68" },
	{ date: "20210108", high: "8.78", low: "8.64" },
	{ date: "20210111", high: "8.95", low: "8.76" },
	{ date: "20210112", high: "8.94", low: "8.68" },
	{ date: "20210113", high: "9.30", low: "8.65" },
	{ date: "20210114", high: "9.25", low: "9.00" },
	{ date: "20210115", high: "9.25", low: "9.04" },
	{ date: "20210118", high: "9.40", low: "9.10" },
	{ date: "20210119", high: "9.75", low: "9.40" },
	{ date: "20210120", high: "10.68", low: "9.90" },
	{ date: "20210121", high: "11.31", low: "10.67" },
	{ date: "20210122", high: "11.86", low: "10.93" },
	{ date: "20210125", high: "11.45", low: "11.10" },
	{ date: "20210127", high: "11.40", low: "10.51" },
	{ date: "20210128", high: "10.38", low: "9.85" },
	{ date: "20210129", high: "10.39", low: "9.17" },
	{ date: "20210201", high: "9.91", low: "9.03" },
	{ date: "20210202", high: "10.12", low: "9.60" },
	{ date: "20210203", high: "10.35", low: "9.96" },
	{ date: "20210204", high: "10.35", low: "10.09" },
	{ date: "20210205", high: "10.25", low: "9.95" },
	{ date: "20210208", high: "10.10", low: "9.92" },
	{ date: "20210209", high: "9.94", low: "9.41" },
	{ date: "20210210", high: "9.45", low: "9.16" },
	{ date: "20210211", high: "9.20", low: "8.88" },
	{ date: "20210212", high: "8.95", low: "8.68" },
	{ date: "20210215", high: "9.20", low: "8.64" },
	{ date: "20210216", high: "9.09", low: "8.90" },
	{ date: "20210217", high: "9.10", low: "8.95" },
	{ date: "20210218", high: "9.02", low: "8.90" },
	{ date: "20210219", high: "9.32", low: "8.91" },
	{ date: "20210222", high: "9.45", low: "8.90" },
	{ date: "20210223", high: "9.00", low: "8.78" },
	{ date: "20210224", high: "8.90", low: "8.70" },
	{ date: "20210225", high: "9.23", low: "8.82" },
	{ date: "20210226", high: "7.29", low: "6.06" },
	{ date: "20210301", high: "6.58", low: "6.25" },
	{ date: "20210302", high: "6.53", low: "5.94" },
	{ date: "20210303", high: "6.08", low: "5.70" },
	{ date: "20210304", high: "5.69", low: "5.05" },
	{ date: "20210305", high: "5.28", low: "4.99" },
	{ date: "20210308", high: "5.28", low: "4.63" },
	{ date: "20210309", high: "5.66", low: "4.75" },
	{ date: "20210310", high: "6.10", low: "5.60" },
	{ date: "20210311", high: "5.71", low: "5.31" },
	{ date: "20210312", high: "5.77", low: "5.41" },
	{ date: "20210315", high: "5.97", low: "5.65" },
	{ date: "20210316", high: "6.00", low: "5.66" },
	{ date: "20210317", high: "5.99", low: "5.68" },
	{ date: "20210318", high: "5.94", low: "5.68" },
	{ date: "20210319", high: "5.65", low: "5.33" },
	{ date: "20210322", high: "5.33", low: "4.99" },
	{ date: "20210323", high: "5.28", low: "5.06" },
	{ date: "20210324", high: "5.13", low: "4.95" },
	{ date: "20210325", high: "5.10", low: "4.85" },
	{ date: "20210326", high: "5.14", low: "5.00" },
	{ date: "20210329", high: "5.12", low: "5.00" },
	{ date: "20210330", high: "5.09", low: "4.95" },
	{ date: "20210331", high: "5.29", low: "5.01" },
	{ date: "20210401", high: "5.27", low: "5.14" },
	{ date: "20210406", high: "5.50", low: "5.25" },
	{ date: "20210407", high: "5.58", low: "5.22" },
	{ date: "20210408", high: "5.49", low: "5.26" },
	{ date: "20210409", high: "5.33", low: "5.21" },
	{ date: "20210412", high: "5.32", low: "5.00" },
	{ date: "20210413", high: "5.15", low: "4.99" },
	{ date: "20210414", high: "5.09", low: "4.97" },
	{ date: "20210415", high: "5.12", low: "5.00" },
	{ date: "20210416", high: "5.27", low: "5.07" },
	{ date: "20210419", high: "5.25", low: "5.13" },
	{ date: "20210420", high: "5.14", low: "4.99" },
	{ date: "20210421", high: "4.60", low: "4.20" },
	{ date: "20210422", high: "4.54", low: "4.26" },
	{ date: "20210423", high: "4.63", low: "4.29" },
	{ date: "20210426", high: "4.66", low: "4.45" },
	{ date: "20210427", high: "4.54", low: "4.36" },
	{ date: "20210428", high: "4.39", low: "4.17" },
	{ date: "20210429", high: "4.32", low: "3.95" },
	{ date: "20210430", high: "4.15", low: "3.98" },
	{ date: "20210503", high: "4.19", low: "3.95" },
	{ date: "20210504", high: "4.06", low: "3.95" },
	{ date: "20210505", high: "4.00", low: "3.81" },
	{ date: "20210506", high: "3.88", low: "3.67" },
	{ date: "20210507", high: "3.68", low: "3.51" },
	{ date: "20210510", high: "3.59", low: "3.34" },
	{ date: "20210511", high: "3.40", low: "3.23" },
	{ date: "20210512", high: "3.49", low: "3.32" },
	{ date: "20210513", high: "3.46", low: "3.23" },
	{ date: "20210514", high: "3.56", low: "3.35" },
	{ date: "20210517", high: "3.40", low: "3.06" },
	{ date: "20210518", high: "3.55", low: "3.07" },
	{ date: "20210519", high: "3.76", low: "3.52" },
	{ date: "20210520", high: "3.65", low: "3.23" },
	{ date: "20210521", high: "3.59", low: "3.39" },
	{ date: "20210524", high: "3.69", low: "3.54" },
	{ date: "20210525", high: "3.84", low: "3.38" },
	{ date: "20210526", high: "3.62", low: "3.37" },
	{ date: "20210527", high: "3.60", low: "3.32" },
	{ date: "20210528", high: "3.55", low: "3.34" },
	{ date: "20210531", high: "3.14", low: "2.70" },
	{ date: "20210601", high: "2.87", low: "2.73" },
	{ date: "20210602", high: "2.84", low: "2.67" },
	{ date: "20210603", high: "2.76", low: "2.67" },
	{ date: "20210604", high: "2.76", low: "2.57" },
	{ date: "20210607", high: "2.81", low: "2.63" },
	{ date: "20210608", high: "2.79", low: "2.66" },
	{ date: "20210609", high: "2.75", low: "2.60" },
	{ date: "20210610", high: "2.72", low: "2.62" },
	{ date: "20210611", high: "2.73", low: "2.63" },
	{ date: "20210615", high: "2.85", low: "2.57" },
	{ date: "20210616", high: "2.82", low: "2.57" },
	{ date: "20210617", high: "2.80", low: "2.59" },
	{ date: "20210618", high: "2.80", low: "2.64" },
	{ date: "20210621", high: "2.68", low: "2.60" },
	{ date: "20210622", high: "2.69", low: "2.58" },
	{ date: "20210623", high: "2.69", low: "2.60" },
	{ date: "20210624", high: "2.67", low: "2.52" },
	{ date: "20210625", high: "2.57", low: "2.45" },
	{ date: "20210628", high: "2.48", low: "2.36" },
	{ date: "20210629", high: "2.57", low: "2.40" }
];

const stockPricesDataMap = new Map(data.map((row) => [row.date, row]));

export default stockPricesDataMap;
